const SatelliteIcon = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 58 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      r="11"
      transform="matrix(-1 0 0 1 31 32)"
      fill="url(#paint0_radial_578_3807)"
    />
    <path d="M1 60.5L57.5 1" stroke="black" />
    <defs>
      <radialGradient
        id="paint0_radial_578_3807"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11 11) scale(128)"
      >
        <stop />
        <stop offset="1" stopColor="#312F2F" />
      </radialGradient>
    </defs>
  </svg>
);

export default SatelliteIcon;
